import Form from "@rjsf/mui"
import validator from "@rjsf/validator-ajv8"
import type { ComponentProps, FC } from "react"
import { FieldTemplate } from "./FieldTemplate"
import { CheckboxWidget } from "./CheckboxWidget"
import { FormStyleHardOverwrites } from "./FormStyleHardOverwrites"
import { JsonFormThemeProvider } from "./JsonFormThemeProvider"
import { ObjectFieldTemplate } from "./ObjectFieldTemplate"
import { SelectWidget } from "./SelectWidget"

function appendFieldNameToTitle(
  schema: ComponentProps<typeof Form>["schema"]
): void {
  if (schema && schema.properties) {
    Object.keys(schema.properties).forEach((key) => {
      const field = schema.properties ? schema.properties[key] : undefined

      if (typeof field === "object" && field) {
        if (field.title && !field.title.includes(`<${key}>`)) {
          field.title = `${field.title}   |   <${key}>`
        }

        if (field.type === "object" && field.properties) {
          appendFieldNameToTitle(field)
        }
      }
    })
  }
}

const prepareSchema = (schema: ComponentProps<typeof Form>["schema"]) => {
  const preparedSchema = {
    ...schema,
    title: "",
    additionalProperties: true,
  }
  appendFieldNameToTitle(preparedSchema)
  return preparedSchema
}

export const JsonForm: FC<
  Omit<ComponentProps<typeof Form>, "schema" | "validator"> & {
    shouldRender?: boolean
    schema?: ComponentProps<typeof Form>["schema"]
  }
> = ({ shouldRender, liveValidate = true, schema, uiSchema, ...props }) => {
  return (
    <JsonFormThemeProvider>
      {schema && shouldRender && (
        <FormStyleHardOverwrites>
          <Form
            validator={validator}
            liveValidate={liveValidate}
            liveOmit={false}
            schema={prepareSchema(schema)}
            omitExtraData={false}
            templates={{ ObjectFieldTemplate, FieldTemplate }}
            widgets={{ CheckboxWidget, SelectWidget }}
            showErrorList="top"
            uiSchema={{
              "ui:options": {
                expandable: false,
                ...uiSchema?.["ui:options"],
              },
              ...uiSchema,
            }}
            {...props}
          />
        </FormStyleHardOverwrites>
      )}
    </JsonFormThemeProvider>
  )
}
